export interface HomeFaq {
  question: string;
  answer: string;
}

export const homeFaqs: HomeFaq[] = [
  {
    question: "How much does it cost to get started?",
    answer:
      "The 7-Day Website Launch starts at $997, with the final setup fee scoped to your project: most builds land between $997 and $1,997 depending on complexity. You only pay the setup fee once your site is live and your first lead is captured, and you can add CRM automation and growth tools later: only when your lead volume demands it.",
  },
  {
    question: "How fast can my website and system go live?",
    answer:
      "Most websites and AI business systems launch in 7 days or less after your strategy call. We build, connect, and launch everything for you: you don't lift a finger.",
  },
  {
    question: "Do I need any technical skills?",
    answer:
      "No. We set up and connect everything: your website, lead capture, AI response tools, follow-up automation, booking flows, and pipeline: so it works together from day one.",
  },
  {
    question: "Am I locked into a contract?",
    answer:
      "No contracts and no forced upgrades. You start with the core website and CRM, then move up a tier only when your lead volume makes it worthwhile.",
  },
  {
    question: "What's actually included in the Frayze system?",
    answer:
      "A conversion-focused website, CRM lead capture, missed-call text-back, automated follow-up, 24/7 AI chat and voice tools, booking flows, automated review requests, and a managed pipeline: all inside one connected platform.",
  },
  {
    question: "Do you only work with Northern Ontario businesses?",
    answer:
      "We're based in Thunder Bay and proudly serve Northern Ontario, but we build websites and growth systems for lead-driven businesses across Canada and the U.S.",
  },
];
